"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Cards = void 0;
var Cards;
(function (Cards) {
    Cards["GS_ARTICLE_CARD"] = "GSArticleCard";
    Cards["GS_VIDEO_CARD"] = "GSVideoCard";
    Cards["GS_PHOTO_CARD"] = "GSPhotoCard";
})(Cards = exports.Cards || (exports.Cards = {}));
